(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-customer-photos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-customer-photos')) {
    class PmCustomerPhotos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = -1;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(Number(d.dataset.dot))));
        this.track?.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.raf);
          this.raf = window.requestAnimationFrame(() => this.update());
        });
        this.track?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
        });
        window.addEventListener('resize', () => this.update());
        const start = Math.min(1, this.cards.length - 1);
        if (start > 0) this.goTo(start, true);
        this.update();
      }

      goTo(i, instant) {
        if (!this.cards.length) return;
        const n = Math.max(0, Math.min(i, this.cards.length - 1));
        const card = this.cards[n];
        const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: instant ? 'auto' : 'smooth' });
        this.setActive(n);
      }

      update() {
        if (!this.cards.length) return;
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let best = 0;
        let dist = Infinity;
        this.cards.forEach((c, n) => {
          const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
          if (d < dist) { dist = d; best = n; }
        });
        this.setActive(best);
      }

      setActive(n) {
        if (n === this.index) return;
        this.index = n;
        this.cards.forEach((c, k) => c.classList.toggle('is-active', k === n));
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      }
    }
    customElements.define('pm-customer-photos', PmCustomerPhotos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-hero-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pm-hero-product')) {
class PmHeroProduct extends HTMLElement {
connectedCallback() {
this.slides = this.querySelector('[data-slides]');
this.slideEls = this.slides ? [...this.slides.children] : [];
this.thumbs = [...this.querySelectorAll('[data-thumb]')];
this.prev = this.querySelector('[data-prev]');
this.next = this.querySelector('[data-next]');
this.index = 0;
const variantsEl = this.querySelector('[data-variants]');
this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
const sizesEl = this.querySelector('[data-sizes]');
this.sizes = sizesEl ? JSON.parse(sizesEl.textContent) : [];
this.unit = 'in';
this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
this.next?.addEventListener('click', () => this.goTo(this.index + 1));
this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.thumb))));
this.slides?.addEventListener('scroll', () => {
window.clearTimeout(this.scrollTimer);
this.scrollTimer = window.setTimeout(() => {
const i = Math.round(this.slides.scrollLeft / this.slides.clientWidth);
this.setIndex(i);
}, 80);
});
this.setIndex(0);
this.querySelectorAll('[data-option-radio]').forEach((r) => r.addEventListener('change', () => this.onOptionChange()));
this.querySelectorAll('[data-qty]').forEach((b) =>
b.addEventListener('click', () => {
const input = this.querySelector('[data-qty-input]');
input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qty));
})
);
this.querySelectorAll('[data-open]').forEach((b) =>
b.addEventListener('click', () => {
const d = this.querySelector(`[data-dialog="${b.dataset.open}"]`);
if (d && typeof d.showModal === 'function') d.showModal();
})
);
this.querySelectorAll('dialog').forEach((d) => {
d.addEventListener('click', (e) => {
if (e.target === d || e.target.closest('[data-close]')) d.close();
});
});
this.querySelectorAll('[data-unit]').forEach((b) =>
b.addEventListener('click', () => {
this.unit = b.dataset.unit;
this.querySelectorAll('[data-unit]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
})
);
this.querySelector('[data-finder-go]')?.addEventListener('click', () => this.findSize());
this.querySelector('[data-finder-input]')?.addEventListener('keydown', (e) => {
if (e.key === 'Enter') {
e.preventDefault();
this.findSize();
}
});
this.querySelector('[data-finder-select]')?.addEventListener('click', (e) => {
this.selectSize(e.currentTarget.dataset.size);
this.querySelector('[data-dialog="finder"]')?.close();
});
}
goTo(i) {
if (!this.slides || !this.slideEls.length) return;
const target = Math.max(0, Math.min(i, this.slideEls.length - 1));
this.slides.scrollTo({ left: target * this.slides.clientWidth, behavior: 'smooth' });
this.setIndex(target);
}
setIndex(i) {
this.index = Math.max(0, Math.min(i, this.slideEls.length - 1));
this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === this.index));
if (this.prev) this.prev.disabled = this.index === 0;
if (this.next) this.next.disabled = this.index >= this.slideEls.length - 1;
}
onOptionChange() {
const selected = [...this.querySelectorAll('fieldset[data-option-index]')].map((fs) => {
const checked = fs.querySelector('input:checked');
const label = fs.querySelector('[data-option-value]');
if (checked && label) label.textContent = checked.value;
return checked ? checked.value : null;
});
const variant = this.variants.find((v) => v.options.every((o, n) => o === selected[n]));
const idInput = this.querySelector('[data-variant-id]');
const atc = this.querySelector('[data-atc]');
const atcLabel = this.querySelector('[data-atc-label]');
if (!variant) {
if (atc) atc.disabled = true;
if (atcLabel) atcLabel.textContent = 'Unavailable';
return;
}
if (idInput) idInput.value = variant.id;
const price = this.querySelector('[data-price]');
const compare = this.querySelector('[data-compare]');
if (price) price.textContent = variant.price;
if (compare) {
compare.hidden = !variant.compare;
if (variant.compare) compare.textContent = variant.compare;
}
if (atc) atc.disabled = !variant.available;
if (atcLabel) {
atcLabel.textContent = variant.available ? this.dataset.atc || 'Add to cart' : this.dataset.soldout || 'Sold out';
}
if (variant.media) {
const i = this.slideEls.findIndex((s) => Number(s.dataset.mediaId) === variant.media);
if (i >= 0) this.goTo(i);
}
}
findSize() {
const input = this.querySelector('[data-finder-input]');
const result = this.querySelector('[data-finder-result]');
const pick = this.querySelector('[data-finder-select]');
const raw = parseFloat(String(input.value).replace(',', '.'));
pick.hidden = true;
if (!raw || raw <= 0 || !this.sizes.length) {
result.textContent = 'Enter your dog’s head measurement.';
return;
}
const inches = this.unit === 'cm' ? raw / 2.54 : raw;
const fits = this.sizes.filter((s) => inches >= s.min && inches <= s.max);
const first = this.sizes[0];
const last = this.sizes[this.sizes.length - 1];
let size = null;
if (fits.length) {
size = fits[fits.length - 1].size;
result.textContent = `We recommend size ${size}.`;
} else if (inches < first.min) {
size = first.size;
result.textContent = `That’s smaller than our ${first.size}. Size ${first.size} is the closest, but it may be loose.`;
} else {
size = last.size;
result.textContent = `That’s larger than our ${last.size}. Size ${last.size} is the closest, but it may be tight.`;
}
pick.dataset.size = size;
pick.textContent = `Select size ${size}`;
pick.hidden = false;
}
selectSize(size) {
const radios = [...this.querySelectorAll('[data-option-radio]')];
const match = radios.find((r) => r.value.trim().toLowerCase() === String(size).trim().toLowerCase());
if (match) {
match.checked = true;
this.onOptionChange();
}
}
}
customElements.define('pm-hero-product', PmHeroProduct);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-topbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-countdown')) {
    class PmCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        if (Number.isNaN(this.end)) {
          this.hidden = true;
          return;
        }
        this.nums = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.nums[el.dataset.unit] = el;
        });
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      finish() {
        clearInterval(this.interval);
        const timer = this.querySelector('.pm-countdown__timer');
        const label = this.querySelector('.pm-countdown__label');
        const ended = this.querySelector('.pm-countdown__ended');
        if (timer) timer.hidden = true;
        if (ended && ended.textContent.trim() !== '') {
          if (label) label.hidden = true;
          ended.hidden = false;
        } else {
          this.hidden = true;
        }
      }

      tick() {
        const diff = this.end - Date.now();
        if (diff <= 0) {
          this.finish();
          return;
        }
        const total = Math.floor(diff / 1000);
        const days = Math.floor(total / 86400);
        let hours = Math.floor((total % 86400) / 3600);
        if (!this.nums.days) hours += days * 24;
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;
        const pad = (n) => String(n).padStart(2, '0');
        if (this.nums.days) this.nums.days.textContent = pad(days);
        if (this.nums.hours) this.nums.hours.textContent = pad(hours);
        if (this.nums.minutes) this.nums.minutes.textContent = pad(minutes);
        if (this.nums.seconds) this.nums.seconds.textContent = pad(seconds);
      }
    }

    customElements.define('pm-countdown', PmCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
